module.exports = __webpack_public_path__ + "img/Contact-icon-3.b6d8e847.svg";